export default __webpack_public_path__ + "static/media/AmericanExpress.016929c7.svg";